import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { useAppSelector, useAppDispatch } from '../reduxhooks';
import { Button, Box, Typography, TextField, InputAdornment } from '@material-ui/core';
import React, { SetStateAction, useEffect } from 'react';
import { openOverlay, updateCurrentScreen } from '../redux/UIOverlayAddressViewRedux';
import { inputAddressForm, resetAddressDraft } from '../redux/AddressRedux';
import EditIcon from '@material-ui/icons/Edit';
import { postAddress } from '../redux/AddressRedux';
import { getCourierOptions, getNumberOfItems, getShipmentPrice, updateAddressInOrder } from '../redux/CartRedux';
import { closeOverlayAndReset } from '../redux/UIOverlayAddressViewRedux';
import { sendWebsiteEventMessage, sendWebsiteLivestreamMessage } from '../telegrambotevents';
import OverlayViewAddressEdit from './OverlayViewAddressEdit';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { signUpAndCheckout, updateState as updateStateAccount } from '../redux/AccountRedux';
import { openOverlay as openOverlayAccount, updateSignUpOrSignIn } from '../redux/UIOverlayAccountViewRedux';
import { ArrowForward } from '@material-ui/icons';
import { phoneNumberSchema } from '../phoneValidation';
import { normalizeIndonesianPhone } from 'common-ts/dist/models/Phone';

function generateUID() {
  // I generate the UID from two parts here 
  // to ensure the random number provide enough bits.
  var firstPart = (Math.random() * 46656) | 0;
  var secondPart = (Math.random() * 46656) | 0;
  var firstPart1 = ("000" + firstPart.toString(36)).slice(-3);
  var secondPart1 = ("000" + secondPart.toString(36)).slice(-3);
  return firstPart1 + secondPart1;
}

const useStyles = makeStyles((theme: Theme) =>
createStyles({
  fontSizeMasukAkun: {
    fontSize: '14px',
    paddingTop: '7px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12.5px',
      paddingTop: '6.5px'
    }
  },
  arrowMasukAkun: {
    marginTop: '4px',
    [theme.breakpoints.down('sm')]: {
      marginTop: '2px'
    }
  },
  errorMessageText: {
    color: '#2e2e2e',
    backgroundColor: 'lightgrey',
    paddingLeft: '10px',
    paddingTop: '10px',
    paddingBottom: '10px',
    marginTop: '14px',
    marginBottom: '4px',
    fontSize: '13px',
    fontWeight: 500,
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: '300px',
    [theme.breakpoints.down('sm')]: {
      width: '240px',
    }
  },
  addressSegmentBody: {
  },
  title: {
    padding: '20px 20px 10px 20px',
    fontWeight: theme.typography.fontWeightBold as number,
    fontSize: '20px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '18px',
    },
  },
  containerStyle: {
    paddingLeft: '20px',
    paddingRight: '20px',
    paddingTop: '5px',
    paddingBottom: '10px',
  },
  nameText: {
    fontWeight: theme.typography.fontWeightBold as number,
    fontSize: '16px',
    marginBottom: '4px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
    },
  },
  bodyText: {
    fontWeight: theme.typography.fontWeightMedium as number,
    fontSize: '15px',
    marginLeft: '3px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
    },
  },
  buttonStyle: {
    marginTop: '5px',
  },
  chooseAddressButton: {
    marginTop: '12px',
  }
}),
);

const validationSchema = yup.object({
  name: yup.string()
    .min(2, 'Your name should be of minimum 4 characters length')
    .required('Your name is required'),
  phone_number: phoneNumberSchema(true),
});

interface PageCheckoutProps {
  checkoutStep: string,
  setCheckoutStep: React.Dispatch<SetStateAction<string>>,
  isDisabled: boolean,
}

export default function PageCheckoutAddress({ checkoutStep, setCheckoutStep, isDisabled } : PageCheckoutProps) {
  const dispatch = useAppDispatch();
  const classes = useStyles();

  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  const cart = useAppSelector((state) => state.cart);
  const errorMessage = useAppSelector(state => state.account.signUpError);

  const formik = useFormik({
    initialValues: {
      name: '',
      phone_number: '',
    },
    validationSchema: validationSchema,
    validateOnChange: true,
    onSubmit: (values) => { // WE DO NOT USE THE SUBMIT FUNCTION HERE.

    },
  });

  useEffect(() => {
    if (errorMessage === "Nomor sudah dipakai.") {
      // We redirect to sign in
      sendWebsiteEventMessage("Nomor sign up (with address) sudah dipakai. Redirect ke sign in.");
      dispatch(openOverlayAccount());
      dispatch(updateSignUpOrSignIn('signIn'));
    }
  }, [errorMessage]);

  return (
    <Box className={classes.addressSegmentBody}>
      <Box style={{
        WebkitTapHighlightColor: 'transparent',
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        margin: '18px 20px 0px',
        padding: '8px 20px 8px',
        backgroundColor: 'rgb(240,240,240)',
        border: '1px solid rgb(211,211,211)',
        borderRadius: '40px',
      }} onClick={() => {
        // We direct to sign in
        sendWebsiteEventMessage("User sudah memiliki akun. Redirect ke sign in.");
        dispatch(openOverlayAccount());
        dispatch(updateSignUpOrSignIn('signIn'));
      }}>
        <Typography className={classes.fontSizeMasukAkun} 
        style={{color: '#000', fontWeight: 300, }}>
          Sudah Punya Akun? <span style={{fontWeight: 400}}><i><u>Masuk Akun Kamu Disini</u></i></span>
        </Typography>
        <Box className={classes.arrowMasukAkun}>
          <ArrowForward/>
        </Box>
      </Box>
      <Box style={{
        display: 'flex',
        flexDirection: 'column',
        padding: '38px 24px 22px',
      }}>
        <Typography variant="h5" style={{
          // marginBottom: '-10px'
        }}>
          Kontak Kamu
        </Typography>
        {
          errorMessage === "" ?
          null :
          <Typography variant="body2" className={classes.errorMessageText}>
            {errorMessage}
          </Typography>
        }
        <TextField
          margin="normal"
          className={classes.textField}
          id="name"
          name="name"
          label="Nama"
          type="text"
          value={formik.values.name}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.name && Boolean(formik.errors.name)}
          helperText={formik.touched.name && formik.errors.name}
        />
        <TextField
          margin="normal"
          className={classes.textField}
          id="phone_number"
          name="phone_number"
          label="Nomor Telepon"
          type="number"
          value={formik.values.phone_number}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.phone_number && Boolean(formik.errors.phone_number)}
          helperText={(formik.touched.phone_number && formik.errors.phone_number) || <span>Pastikan nomor telepon kamu <span style={{fontWeight: 500, color: '#292929'}}>bisa dihubungi.</span></span>}
          InputProps={{
            startAdornment: <InputAdornment position="start">+62</InputAdornment>,
          }}
        />
      </Box>
      <OverlayViewAddressEdit skipPhoneNumber={true} isLoadingSubmit={isLoading} 
      submitText={"PILIH KURIR"}
      handleSubmit={(address)=>{
        // IMPLEMENTATION NOTE:
        // THIS COMBINES TWO DIFFERENT FORMS INTO ONE ACTION.

        // Step 0. Check if name and phone number values are valid
        if (!formik.isValid) {
          return;
        }
        setIsLoading(true);

        // Step 1. Sign up and post the address (2 actions at the same time)
        const emailAuto = generateUID() + '@studios.id';
        // Two UIDs: a single one is only 6 chars, below the backend's 8-char minimum.
        const passwordAuto = generateUID() + generateUID();
        dispatch(updateStateAccount({
          name: formik.values.name,
          phoneNumber: '+62' + formik.values.phone_number,
          email: emailAuto,
        }));
        dispatch(signUpAndCheckout({
          password: passwordAuto,
          addressObject: address,
          onSuccessCallback: (idToken: string) => {
            // Step 2. Update address in current state.
            dispatch(updateAddressInOrder({
              addressName: address.addressName,
              address: address.address,
              provinsi: address.provinsi,
              kabupaten: address.kabupaten,
              kecamatan: address.kecamatan,
              kodePos: address.kodePos,
              kotaKecamatanText: address.kotaKecamatanText,
              keterangan: address.keterangan,
              // Canonical 628… — what the backend stores and what the
              // checkout thunk reads first.
              phoneNumber: normalizeIndonesianPhone(formik.values.phone_number),
              destinationObject: address.destinationObject,
              destinationKiriminAjaObject: address.destinationKiriminAjaObject,
            }));

            // Step 3. Post the newly acquired address.
            dispatch(inputAddressForm({
              phoneNumber: normalizeIndonesianPhone(formik.values.phone_number),
              creationDateTime: new Date().toISOString(),
            }));
            dispatch(postAddress(idToken));
    
            // Step 4. Get courier options.
            // Fetch courier options
            if (address?.destinationKiriminAjaObject?.kecamatan_id) {
              dispatch(getCourierOptions({
                dest: address?.destinationKiriminAjaObject?.kecamatan_id,
              }));
              sendWebsiteLivestreamMessage("[CHECKOUT] Address (with sign up) entered, fetching courier options.");
    
              setCheckoutStep("courier");
              (window as any)?.scrollTo({top: 0, behavior: 'smooth'});
            }
          },
          onFailureCallback: () => {
            setIsLoading(false);
          }
        }))
        }}/>
    </Box>
  )
}
